<template>
  <div>
    <Header />
    <Banner />
    <HandwareProductsPage />
    <Footer />
  </div>
</template>
<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import HandwareProductsPage from '../components/HandwareProductsPage.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'HandwareProducts',
  components: {
    Banner,
    Footer,
    HandwareProductsPage,
    Header
  }
}
</script>